import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=9332c64a&scoped=true"
import script from "./OnboardingHeader.vue?vue&type=script&lang=ts"
export * from "./OnboardingHeader.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=9332c64a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9332c64a",
  null
  
)

export default component.exports